export const ltoBannerDefaults = {
  enabled: true,
  portal: false,
  backgroundColor: 'electricity',
  icon: 'star',
  useBackgroundTheme: false,
  backgroundTheme: 'default',
  iconColor: 'darkBlue',
  emphasized: 'Great news!',
  copy: 'Order now and get expert installation included with any Fiber internet plan, a $100 value.',
  ngcCopy: 'Order now and get expert installation included with any Fiber internet plan, a $100 value.',
  legalKey: 'none',
  tooltip: 'none',
  disclaimer: 'none',
  displayStyle: 'none',
  netflixToggleLink: {
    enabled: false,
    text: 'Shop bundle plans',
  },
} as const;
